<template>
  <EngageWorkspaceHeader v-if="showUnifiedEngageWorkspace" title="Engage" />
  <ConfigurablePage
    page-identifier="market_overview"
    :show-page-header="!showUnifiedEngageWorkspace"
  />
</template>

<script>
import ConfigurablePage from '@/components/ConfigurablePage.vue';
import EngageWorkspaceHeader from '@/components/navigation/EngageWorkspaceHeader.vue';
import { POSTHOG_FLAGS } from '@/constants/posthogFlags';
import { isPostHogFlagEnabled } from '@/utils/posthogFlags';

export default {
  name: 'Overview_List_Engage',
  components: {
    ConfigurablePage,
    EngageWorkspaceHeader,
  },
  computed: {
    showUnifiedEngageWorkspace() {
      return isPostHogFlagEnabled(POSTHOG_FLAGS.UNIFIED_ENGAGE_WORKSPACE);
    },
  },
};
</script>
